






































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import OrderDarahSvc from "@/services/OrderDarah";
import { storeOrderDarah } from "@/store/modules/OrderDarahStore";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import IdentitasPasienRingkas from "./IdentitasPasienRingkas.vue";
import { identitasDariStore } from "@/utils/identitasPasienRingkas";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { localISODate } from "@/utils/localDate";
import {
  KELAS_OPTIONS,
  prefillBangsalKelas
} from "@/utils/prefillBangsalKelas";
import { maskTekananDarah, validasiTekananDarah } from "@/utils/tekananDarah";
import { ORDER_DARAH } from "./orderDarah.config";
import type { OrderDarahJenis } from "@/types/order_darah";

@Component({
  components: { UnitRuangPicker, VCDateTimePicker, IdentitasPasienRingkas },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class OrderDarahFormDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;

  @Prop({ type: String, required: true }) readonly jenis!: OrderDarahJenis;

  @Prop() readonly register!: string;

  @Prop() readonly rm!: string;

  @Prop({ default: null }) readonly editData!: any;

  isReadOnly!: () => boolean;

  saving = false;

  simpanTtd = false;

  pesanTd: string[] = [];

  kelasOptions = KELAS_OPTIONS;

  bagianOptions = [
    { text: "Anak", value: "anak" },
    { text: "Bedah", value: "bedah" },
    { text: "Kebidanan/Kandungan", value: "kebidanan" },
    { text: "Penyakit Dalam", value: "penyakit_dalam" },
    { text: "Lain-lain", value: "lain" }
  ];

  form: any = this.emptyForm();

  get dialog(): boolean {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit("input", val);
  }

  get cfg() {
    return ORDER_DARAH[this.jenis];
  }

  get meta() {
    return storeOrderDarah.katalog[this.jenis] || null;
  }

  get blok() {
    return this.meta ? this.meta.blok : null;
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get lockedForm(): boolean {
    return this.readOnly || !!(this.editData && this.editData.is_locked);
  }

  get listDokter() {
    return storeDokter.list;
  }

  punyaExtra(field: string): boolean {
    return !!(
      this.meta &&
      this.meta.extra_fields &&
      Object.prototype.hasOwnProperty.call(this.meta.extra_fields, field)
    );
  }

  get pilihLainnya(): boolean {
    if (!this.blok || !this.blok.lainnya_key) return false;
    const dipilih = this.form.detail[this.blok.key];
    return Array.isArray(dipilih) && dipilih.indexOf(this.blok.lainnya_value) >= 0;
  }

  get identitas() {
    return identitasDariStore(this.register);
  }

  get pakaiJenisOrder(): boolean {
    return this.jenis === "komponen_rujukan";
  }

  get alasanTidakBisaTtd(): string {
    const userId = userModule.user ? userModule.user.id : null;
    if (!this.form.dokter_peminta_user_id) {
      return "Pilih Dokter yang Meminta untuk menandatangani";
    }
    if (String(this.form.dokter_peminta_user_id) !== String(userId)) {
      return "Tanda tangan hanya oleh dokter yang meminta";
    }
    return "";
  }

  get tglPermintaan(): Date | null {
    if (!this.form.tanggal_permintaan) return null;
    const [y, m, d] = String(this.form.tanggal_permintaan).split("-").map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  }

  set tglPermintaan(val: Date | null) {
    this.form.tanggal_permintaan = val ? localISODate(val) : null;
  }

  emptyDetail(): Record<string, any> {
    const blok = this.blok;
    if (!blok || blok.tipe === "none") return {};

    const out: Record<string, any> = {};
    out[blok.key] = blok.tipe === "checkbox" ? [] : "";
    if (blok.lainnya_key) out[blok.lainnya_key] = "";
    return out;
  }

  emptyForm() {
    return {
      id: null,
      bangsal: null,
      kelas: null,
      bagian: null,
      bagian_lain: null,
      jaminan_manual: null,
      diagnosa: null,
      tanggal_permintaan: localISODate(new Date()),
      hal_lain: null,
      hb_hmt: null,
      tekanan_darah: null,
      dokter_peminta_user_id: null,
      jenis_order: "langsung",
      detail: {}
    };
  }

  @Watch("value")
  onDialogToggle(val: boolean) {
    if (!val) return;

    if (this.editData) {
      this.hydrate();
    } else {
      this.form = {
        ...this.emptyForm(),
        detail: this.emptyDetail(),
        ...prefillBangsalKelas(RegisterKunjungan.register, this.register)
      };
      if (userModule.user && userModule.user.profesi === "Dokter") {
        this.form.dokter_peminta_user_id = userModule.user.id;
      }
    }

    this.pesanTd = [];
  }

  @Watch("blok")
  onBlokLoaded() {
    if (!this.value) return;

    this.form.detail = { ...this.emptyDetail(), ...this.form.detail };
  }

  hydrate() {
    const d = this.editData;
    this.form = {
      id: d.id,
      bangsal: d.bangsal,
      kelas: d.kelas,
      bagian: d.bagian,
      bagian_lain: d.bagian_lain,
      jaminan_manual: d.jaminan_manual,
      diagnosa: d.diagnosa,
      tanggal_permintaan: d.tanggal_permintaan,
      hal_lain: d.hal_lain,
      hb_hmt: d.hb_hmt,
      tekanan_darah: d.tekanan_darah,
      dokter_peminta_user_id: d.dokter_peminta_user_id,
      jenis_order: d.jenis_order || "langsung",
      detail: { ...this.emptyDetail(), ...(d.detail || {}) }
    };
  }

  onTdInput(val: string) {
    const bersih = maskTekananDarah(val || "", this.form.tekanan_darah || "");

    if (bersih === this.form.tekanan_darah) {
      const ref: any = this.$refs.tdRef;
      if (ref) ref.lazyValue = bersih;
    }

    this.form.tekanan_darah = bersih;
    const cek = validasiTekananDarah(bersih);
    this.pesanTd = cek === true ? [] : [cek];
  }

  cekIsianWajib(): string | null {
    const kurang: string[] = [];

    const wajib: Array<[string, any]> = [
      ["Dokter yang Meminta", this.form.dokter_peminta_user_id],
      ["Ruang Rawat", this.form.bangsal],
      ["Kelas", this.form.kelas],
      ["Dirawat di Bagian", this.form.bagian],
      ["Diagnosa", this.form.diagnosa],
      ["Tanggal Permintaan", this.form.tanggal_permintaan]
    ];

    wajib.forEach(([label, nilai]) => {
      if (nilai === null || nilai === undefined || nilai === "") kurang.push(label);
    });

    if (this.form.bagian === "lain" && !this.form.bagian_lain) {
      kurang.push("Sebutkan Bagian");
    }

    if (this.punyaExtra("hb_hmt") && !this.form.hb_hmt) kurang.push("HB / HMT");
    if (this.punyaExtra("tekanan_darah") && !this.form.tekanan_darah) {
      kurang.push("Tekanan Darah");
    }

    const blok = this.blok;
    if (blok && blok.required) {
      const nilai = this.form.detail[blok.key];
      if (blok.tipe === "text" && !nilai) {
        kurang.push(blok.label);
      }
      if (blok.tipe === "checkbox" && (!Array.isArray(nilai) || !nilai.length)) {
        kurang.push(blok.label);
      }
    }

    if (this.pilihLainnya && !this.form.detail[this.blok.lainnya_key]) {
      kurang.push(this.blok.lainnya_label || "Keterangan lainnya");
    }

    return kurang.length ? "Lengkapi dulu: " + kurang.join(", ") + "." : null;
  }

  buildPayload() {
    return {
      jenis: this.jenis,
      register_id: this.register,
      pasien_rm: this.rm,
      unit_pemohon_id: userModule.user ? userModule.user.unit_id : null,
      dokter_peminta_user_id: this.form.dokter_peminta_user_id,
      bangsal: this.form.bangsal,
      kelas: this.form.kelas,
      bagian: this.form.bagian,
      bagian_lain: this.form.bagian === "lain" ? this.form.bagian_lain : null,
      jaminan_manual: this.form.jaminan_manual,
      diagnosa: this.form.diagnosa,
      tanggal_permintaan: this.form.tanggal_permintaan,
      hal_lain: this.form.hal_lain,
      hb_hmt: this.punyaExtra("hb_hmt") ? this.form.hb_hmt : null,
      tekanan_darah: this.punyaExtra("tekanan_darah") ? this.form.tekanan_darah : null,
      jenis_order: this.pakaiJenisOrder ? this.form.jenis_order || "langsung" : "langsung",
      detail: this.form.detail
    };
  }

  async simpan(tandatangani = false) {
    if (this.lockedForm || this.saving) return;
    if (tandatangani && this.alasanTidakBisaTtd) {
      appModule.sendErrorAlert(this.alasanTidakBisaTtd);
      return;
    }

    const kurang = this.cekIsianWajib();
    if (kurang) {
      appModule.sendErrorAlert(kurang);
      return;
    }

    if (this.punyaExtra("tekanan_darah")) {
      const cek = validasiTekananDarah(this.form.tekanan_darah || "");
      if (cek !== true) {
        appModule.sendErrorAlert(cek);
        return;
      }
    }

    this.saving = true;
    this.simpanTtd = tandatangani;
    try {
      const payload = this.buildPayload();
      const resp = this.form.id
        ? await OrderDarahSvc.update(this.form.id, payload)
        : await OrderDarahSvc.create(payload);

      if (resp.data.status == "1") {
        appModule.sendSuccessNotice(resp.data.message || "Berhasil disimpan");
        this.dialog = false;
        this.$emit("saved", { data: resp.data.data, tandatangani });
      }
    } catch {
      return;
    } finally {
      this.saving = false;
      this.simpanTtd = false;
    }
  }

  tutup() {
    this.dialog = false;
  }
}
